import React from 'react';
import PropTypes from 'prop-types';
import { Col, KeyValue, NoValue, Row } from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import useDataByName from '../../../../hooks/useDataByName';
import { getCustomFieldValue } from '../../../../utils/utils';

function SelectFieldView({ fieldValues, locale, data }) {
  const { name, label, schema, dataOptionsSource, fieldDataOption } =
    fieldValues;
  const dataSource = useDataByName(dataOptionsSource);

  const fieldLabel = label.find((field) => field.locale === locale)?.value;
  const value =
    schema === 'default' ? data[name] : getCustomFieldValue(name, data);

  const dataSourceValue = dataSource?.find((field) => field.id === value)?.name;
  const fieldDataOptionValue = fieldDataOption
    .find((field) => field.value === value)
    ?.label.find((field) => field.locale === locale)?.value;

  const fieldValue =
    schema === 'default' ? dataSourceValue : fieldDataOptionValue;

  return (
    <Row>
      <Col xs={12}>
        <KeyValue
          label={fieldLabel}
          value={
            fieldValue ? (
              <FormattedMessage
                id={`ui-inventory.${dataOptionsSource}.name.${fieldValue}`}
                defaultMessage={fieldValue}
              />
            ) : (
              <NoValue />
            )
          }
        />
      </Col>
    </Row>
  );
}

SelectFieldView.propTypes = {
  fieldValues: PropTypes.object,
  locale: PropTypes.string,
  data: PropTypes.object,
};

export default SelectFieldView;
